module.exports = __webpack_public_path__ + "media/assets/faria_products/OpenApply-0c376f91c61918fa5708dd4acc9bd9fa6e920e4a7887c1ffd6ef0f84de7c9ce5.png";